import React from 'react';
import LinkArrow from '../../global/LinkArrow';
import Lottie from 'react-lottie';
interface Item {
  title: string;
  description: string;
  icon: React.ElementType;
}

interface DemoSectionProps {
  title: string;
  subTitle: string;
  description: string;
  link: {
    title: string;
    href: string;
  };
  lottie: any;
  items: readonly Item[];
}

export const DemoSection = ({
  title,
  subTitle,
  description,
  link,
  lottie,
  items,
}: DemoSectionProps) => {
  const getLottieOptions = (lottieData: any) => ({
    loop: true,
    autoplay: true,
    animationData: lottieData,
  });
  return (
    <section className="py-20">
      <div className="flex flex-col gap-8 overflow-hidden">
        <h2 className="text-2xl lg:text-5xl font-medium max-w-[40rem] text-center mx-auto">
          {title}
        </h2>
        <svg
          width="1260"
          height="2"
          viewBox="0 0 1260 2"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 1L1260 1.00011" stroke="#DBDBDB" />
        </svg>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 px-2 lg:px-8">
          <h3 className="col-span-1 lg:col-span-1 text-xl lg:text-3xl font-medium">
            {subTitle}
          </h3>
          <div className="col-span-1 lg:col-span-1 flex flex-col">
            <p className="mb-6">{description}</p>
            <LinkArrow to={link.href} color="orange">
              {link.title}
            </LinkArrow>
          </div>
        </div>
        <div className="w-full lg:px-8">
          <Lottie options={getLottieOptions(lottie)} />
        </div>
        <div className="mt-12 px-2 lg:px-8 grid grid-cols-3 gap-x-12 gap-y-8">
          {items.map((item, index) => {
            const Icon = item.icon;
            return (
              <div
                key={index}
                className="col-span-3 lg:col-span-1 flex flex-col items-start"
              >
                <Icon className="w-8 h-8" />
                <h4 className="font-medium text-lg lg:text-2xl mb-2">{item.title}</h4>
                <p className="text-gray-600">{item.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
